export const has = (obj, prop) => {
    return Object.prototype.hasOwnProperty.call(obj, prop);
};
export const get = (object, path, defaultValue = undefined) => {
    if (!path)
        throw TypeError('path should be a non-empty string');
    const keys = path.split('.');
    let curr = object;
    while (curr && keys.length) {
        const key = keys.shift();
        if (!key || !has(curr, key))
            return defaultValue;
        curr = curr[key];
    }
    return curr;
};
export function listToMap(objList, idProp) {
    const mapObj = {};
    Object.entries(objList).forEach(([_, v]) => {
        mapObj[v[idProp]] = v;
    });
    return mapObj;
}
